/**
 * @license
 * ts-browser-helpers v0.17.1
 * Copyright 2022-2025 repalash <palash@shaders.app>
 * MIT License
 * See ./dependencies.txt for bundled third-party dependencies and licenses.
 */
class M {
  constructor() {
    this._eventListeners = {}, this.dispatchEvent = this.dispatchEvent.bind(this), this.addEventListener = this.addEventListener.bind(this), this.removeEventListener = this.removeEventListener.bind(this), this.hasEventListener = this.hasEventListener.bind(this);
  }
  addEventListener(e, t) {
    const i = this._eventListeners;
    i[e] === void 0 && (i[e] = []), i[e].includes(t) || i[e].push(t);
  }
  hasEventListener(e, t) {
    const i = this._eventListeners;
    return i[e] !== void 0 && i[e].includes(t);
  }
  removeEventListener(e, t) {
    const r = this._eventListeners[e];
    if (r !== void 0) {
      const o = r.indexOf(t);
      o !== -1 && r.splice(o, 1);
    }
  }
  dispatchEvent(e) {
    const i = this._eventListeners[e.type];
    if (i !== void 0) {
      e.target = this;
      const r = i.slice(0);
      for (let o = 0, s = r.length; o < s; o++) r[o].call(this, e);
    }
  }
}
async function re(n) {
  return new Promise((e) => setTimeout(e, Math.max(0, n)));
}
function w() {
  return (typeof performance > "u" ? Date : performance).now();
}
class oe extends M {
  constructor() {
    super(...arguments), this._onPointerDown = (e) => {
      if (e.button !== 0 || !this._element) return;
      this._pointerUp = void 0;
      const t = e.clientX / this._element.clientWidth * 2 - 1, i = -(e.clientY / this._element.clientHeight) * 2 + 1, r = w();
      this._pointerDown = { x: t, y: i, time: r }, this._pointer = this._pointerDown, this.dispatchEvent({ type: "dragStart", pointer: this._pointerDown });
    }, this._onPointerMove = (e) => {
      if (!this._pointerDown || !this._pointer || !this._element) return;
      const t = e.clientX / this._element.clientWidth * 2 - 1, i = -(e.clientY / this._element.clientHeight) * 2 + 1, r = w();
      this.dispatchEvent({
        type: "drag",
        pointer: this._pointer,
        drag: { x: t - this._pointerDown.x, y: i - this._pointerDown.y, time: r - this._pointerDown.time },
        delta: { x: t - this._pointer.x, y: i - this._pointer.y, time: r - this._pointer.time }
      }), this._pointer = { x: t, y: i, time: w() }, e.buttons % 2 === 0 && this._onPointerUp(e);
    }, this._onPointerUp = (e) => {
      if (e.button !== 0 || !this._pointerDown || !this._element) return;
      const t = e.clientX / this._element.clientWidth * 2 - 1, i = -(e.clientY / this._element.clientHeight) * 2 + 1, r = w();
      this._pointerUp = { x: t, y: i, time: r }, this.dispatchEvent({
        type: "dragEnd",
        pointer: this._pointerUp,
        drag: {
          x: this._pointerUp.x - this._pointerDown.x,
          y: this._pointerUp.y - this._pointerDown.y,
          time: this._pointerUp.time - this._pointerDown.time
        }
      }), this._pointerDown = void 0, this._pointer = void 0;
    };
  }
  get element() {
    return this._element;
  }
  set element(e) {
    this._element !== e && (this._element && this._removeElement(), this._element = e, this._element && this._addElement());
  }
  _removeElement() {
    var e, t, i, r, o;
    (e = this._element) == null || e.removeEventListener("pointerdown", this._onPointerDown), (t = this._element) == null || t.removeEventListener("pointermove", this._onPointerMove), (i = this._element) == null || i.removeEventListener("pointerup", this._onPointerUp), (r = this._element) == null || r.removeEventListener("pointercancel", this._onPointerUp), (o = this._element) == null || o.removeEventListener("pointerout", this._onPointerUp);
  }
  _addElement() {
    var e, t, i, r, o;
    (e = this._element) == null || e.addEventListener("pointerdown", this._onPointerDown), (t = this._element) == null || t.addEventListener("pointermove", this._onPointerMove), (i = this._element) == null || i.addEventListener("pointerup", this._onPointerUp), (r = this._element) == null || r.addEventListener("pointercancel", this._onPointerUp), (o = this._element) == null || o.addEventListener("pointerout", this._onPointerUp);
  }
  dispose() {
    this.element = void 0;
  }
}
/*!
 * Fork Of -
 * JavaScript Undo Manager 1.0.0
 * Simple JavaScript undo/redo command manager supporting transactions with no dependencies.
 *
 * Copyright: Alexey Grinko, 2017
 * Git repository: https://github.com/agrinko/js-undo-manager.git
 *
 * @license MIT - https://opensource.org/licenses/MIT
 *
 * Changes -
 * 1. Added presets commands
 * 2. Port to TypeScript
 * 3. Remove transactions
 */
class se {
  constructor(e) {
    this.options = {
      limit: 500,
      // maximum commands stack size
      debug: !1,
      // whether to emit execution status in console
      bindHotKeys: !1
      // whether to bind "undo" and "redo" commands to "Ctrl+Z", "Ctrl+Y" & "Ctrl+Shift+Z" hot keys
      // useTransactions: true   // whether to initialize transactions manager
    }, this.enabled = !0, this.presets = {}, this._keyDown = (t) => {
      if (!this.enabled) return;
      const i = t.ctrlKey || t.metaKey;
      t.code === "KeyZ" && i && !t.shiftKey ? this.undo() : (t.code === "KeyZ" && i && t.shiftKey || t.code === "KeyY" && t.ctrlKey) && this.redo();
    }, Object.assign(this.options, e), this.limit = e.limit, this.options = e, this.reset(), e.bindHotKeys && this.bindHotKeys(), this.log(`Initialized with stack limit of ${this.limit} commands`);
  }
  /**
   * Bind 'undo' and 'redo' actions to 'Ctrl/Cmd+Z', 'Ctrl+Y' & 'Ctrl/Cmd+Shift+Z' hot keys.
   * It is a basic implementation for quick testing and should be replaced with custom event handlers
   * for more flexible processing.
   * @returns {JSUndoManager}
   */
  bindHotKeys() {
    return this.log("Bound 'undo' and 'redo' actions to 'Ctrl/Cmd+Z', 'Ctrl+Y' & 'Ctrl/Cmd+Shift+Z' hot keys"), (this.options.hotKeyRoot ?? document).addEventListener("keydown", this._keyDown), this;
  }
  dispose() {
    return (this.options.hotKeyRoot ?? document).removeEventListener("keydown", this._keyDown), this.reset();
  }
  /**
   * Remember executed command containing "redo" and "undo" functions
   * @param {Object|Function} command - either an object with "redo" and "undo" functions
   * @returns {JSUndoManager}
   */
  record(e) {
    return this.enabled ? (this._record(e), this) : this;
  }
  replaceLast(e) {
    const t = this.peek();
    if (t)
      return this.log("replace", t, "with", e), this.stack[this.sp] = e, this;
  }
  /**
   * Execute function and record it with its opposite "undo" function
   * @param {Object|Function} command - either an object with "redo" and "undo" functions
   * @param {Function} [undo] - "undo" function, used if the first argument is also a function
   * @returns {JSUndoManager}
   */
  execute(e) {
    if (!this.enabled) return;
    let t = this._rc(e), i = t.redo;
    return this.record.apply(this, t), this.log("Executing function..."), i.apply(e), this;
  }
  _rc(e) {
    if (e.type) {
      const t = this.presets[e.type];
      if (typeof t == "function")
        return t(e);
      throw console.error(e, t, this.presets), new Error("Preset command not found");
    } else
      return e;
  }
  _record(e) {
    this.enabled && (this.log("Recording command", e), this._rebase(), this.stack.push(e), this.sp++, this._keepLimit());
  }
  //forget "future" commands if stack pointer is not at the end
  _rebase() {
    this.canRedo() && (this.stack.length = this.sp + 1);
  }
  //sustain limited size of stack; cut extra commands starting with the latest ones
  _keepLimit() {
    if (this.stack.length <= this.limit)
      return;
    let e = this.stack.length - this.limit;
    this.log("Stack size reached its limit: ${this.limit} commands. Cutting off most old commands..."), e === 1 ? this.stack.shift() : this.stack.splice(0, e), this.sp -= e;
  }
  /**
   * Undo previous command if possible
   * @returns {JSUndoManager}
   */
  undo() {
    if (!this.canUndo())
      return this;
    let e = this.stack[this.sp];
    return this.log("undo"), this.sp--, this._rc(e).undo(), this;
  }
  /**
   * Check whether undoing previous command is possible
   * @returns {boolean}
   */
  canUndo() {
    return this.sp >= 0 && this.enabled;
  }
  /**
   * Get the last command that was done
   */
  peek() {
    return this.canUndo() ? this.stack[this.sp] : null;
  }
  /**
   * Redo the command which was previously undone
   * @returns {JSUndoManager}
   */
  redo() {
    if (!this.canRedo())
      return this;
    let e = this.stack[this.sp + 1];
    return this.log("redo"), this.sp++, this._rc(e).redo(), this;
  }
  /**
   * Check whether redoing command is possible
   * @returns {boolean}
   */
  canRedo() {
    return this.sp < this.stack.length - 1 && this.enabled;
  }
  /**
   * Gets the last command that was undone
   */
  peekForward() {
    return this.canRedo() ? this.stack[this.sp + 1] : null;
  }
  /**
   * Change stack size limit initially defined in the constructor options
   * @param {number} limit
   */
  setLimit(e) {
    let t = this.stack.length - this.sp - 1;
    if (e < 1 || typeof e != "number")
      throw new TypeError(`JSUndoManager.setLimit(): unexpected argument limit=${e}. Should be a positive number`);
    return e < t ? console.warn(`JSUndoManager.setLimit(): cannot set stack limit (${e}) less than the number of 'redoable' commands (${t})`) : (this.limit = Math.floor(e), this._keepLimit()), this;
  }
  /**
   * Reset all commands from memory
   */
  reset() {
    return this.log("reset"), this.stack = [], this.sp = -1, this;
  }
  /**
   * Check whether the commands stack is empty
   * @returns {boolean}
   */
  isEmpty() {
    return !this.stack.length;
  }
  /**
   * Check whether the commands stack size reaches its limit
   * @returns {boolean}
   */
  isFull() {
    return this.stack.length === this.limit;
  }
  /**
   * Get number of commands in memory stack
   * @returns {Number}
   */
  getSize() {
    return this.stack.length;
  }
  log(e, ...t) {
    this.options.debug && console.log(`Command Manager: ${e}`, ...t);
  }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const m = class m {
  constructor(e = m.DECAY_MILLISECONDS) {
    this.velocity = 0, this.naturalFrequency = 0, this.setDecayTime(e);
  }
  setDecayTime(e) {
    this.naturalFrequency = 1 / Math.max(m.MIN_DECAY_MILLISECONDS, e);
  }
  update(e, t, i, r) {
    const o = 2e-4 * this.naturalFrequency;
    if (e == null || r === 0 || e === t && this.velocity === 0)
      return t;
    if (i < 0)
      return e;
    const s = e - t, a = this.velocity + this.naturalFrequency * s, c = s + i * a, l = Math.exp(-this.naturalFrequency * i), d = (a - this.naturalFrequency * c) * l, f = -this.naturalFrequency * (d + a * l);
    return Math.abs(d) < o * Math.abs(r) && f * s >= 0 ? (this.velocity = 0, t) : (this.velocity = d, t + c * l);
  }
};
m.SETTLING_TIME = 1e4, m.MIN_DECAY_MILLISECONDS = 1e-3, m.DECAY_MILLISECONDS = 50;
let S = m;
function ae() {
  const n = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
  return n.style.display = "block", n;
}
function ce({ innerHTML: n = "", id: e, classList: t, addToBody: i = !0, elementTag: r = "div" }) {
  const o = document.createElement(r);
  return e && (o.id = e), o.innerHTML = n, t && o.classList.add(...t), i && document.body.appendChild(o), o;
}
async function $(n) {
  return new Promise((e, t) => {
    const i = new Image();
    i.onload = () => e(i), i.onerror = t, i.crossOrigin = "anonymous", i.decoding = "sync", i.src = n;
  });
}
function R(n, e = document.head) {
  const t = document.createElement("style");
  return t.type = "text/css", t.innerText = n, e == null || e.appendChild(t), t;
}
async function le(n, e = document.head) {
  return new Promise((t, i) => {
    const r = document.createElement("script");
    r.setAttribute("src", n), r.addEventListener("load", () => t(r)), r.addEventListener("error", i), e.appendChild(r);
  });
}
async function ue(n, e) {
  var i;
  n.innerHTML = e;
  const t = n.getElementsByTagName("script");
  for (let r = 0; r < t.length; r++) {
    const o = t[r], s = F(o);
    let a = !1;
    await new Promise((c) => {
      s.onload = c, s.onerror = () => {
        a = !0, c(void 0);
      };
    }), !a && ((i = o.parentNode) == null || i.replaceChild(s, o));
  }
}
function F(n, e) {
  e = e ?? document.createElement("script"), e.type = n.type || "text/javascript", e.text = n.text;
  for (let t = 0; t < n.attributes.length; t++) {
    const i = n.attributes[t];
    e.setAttribute(i.name, i.value);
  }
  return e;
}
function de(n) {
  if (!window)
    return console.warn("window is required"), "";
  let e = "";
  const t = new Uint8Array(n), i = t.byteLength;
  for (let r = 0; r < i; r++)
    e += String.fromCharCode(t[r]);
  return window.btoa(e);
}
function he(n) {
  if (!window)
    return console.warn("window is required"), new Uint8Array(0);
  const e = window.atob(n), t = e.length, i = new Uint8Array(t);
  for (let r = 0; r < t; r++)
    i[r] = e.charCodeAt(r);
  return i.buffer;
}
const N = {
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
};
function fe(n, e) {
  return new N[n](e);
}
function pe(n) {
  return n.replace(
    /\w\S*/g,
    function(e) {
      return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
    }
  );
}
function me(n) {
  return n.replace(
    /([-_][a-z])/ig,
    (e) => e.toUpperCase().replace("-", "").replace("_", "")
  );
}
function ge(n) {
  if (!n || n === "" || n.match(/__MACOSX\/.*\._/)) return "";
  n = n.replace(/\?.*$/, "");
  const e = n.split(/[\\/]/).pop() ?? "", t = e.lastIndexOf(".");
  return e === "" || t < 1 ? "" : e.slice(t + 1);
}
function we(n) {
  return n.substring(n.lastIndexOf("/") + 1);
}
function q(n) {
  return n.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function h(n, e, t) {
  return n.replace(new RegExp(q(e), "g"), t);
}
function ye(n, e, t, {
  replaceAll: i = !1,
  prepend: r = !1,
  append: o = !1,
  notFoundCallback: s = () => {
  }
} = {}) {
  if (s && !n.includes(e))
    return s(), n;
  let a = t;
  return r ? a = t + e : o && (a = e + t), i ? n.replaceAll(e, a) : n.replace(e, a);
}
function ve(n) {
  return n.sort(), n[0].split("").map((e, t) => n[n.length - 1][t] === e ? e : "\0").join("").split("\0").at(0) || "";
}
const be = (n, ...e) => String.raw({ raw: n }, ...e), H = (n, ...e) => String.raw({ raw: n }, ...e), xe = (n, ...e) => String.raw({ raw: n }, ...e), W = (n, ...e) => {
  let t = String.raw({ raw: n }, ...e);
  return t = h(t, "%", "%25"), t = h(t, "> <", "><"), t = h(t, "; }", ";}"), t = h(t, "<", "%3c"), t = h(t, ">", "%3e"), t = h(t, '"', "'"), t = h(t, "#", "%23"), t = h(t, "{", "%7b"), t = h(t, "}", "%7d"), t = h(t, "|", "%7c"), t = h(t, "^", "%5e"), t = h(t, "`", "%60"), t = h(t, "@", "%40"), t = h(t, "&", "&amp;"), t = h(t, `
`, "%0A"), "data:image/svg+xml;charset=UTF-8," + t;
};
function ke(n = document.head) {
  return R(H`
      ::-webkit-scrollbar
      {
        width: 8px;  /* for vertical scrollbars */
        height: 8px; /* for horizontal scrollbars */
      }
      ::-webkit-scrollbar-track
      {
        background: rgba(64, 64, 64, 0.4);
        border-radius: 6px;
      }
      ::-webkit-scrollbar-thumb
      {
        background: rgba(128, 128, 128, 0.2);
        border-radius: 6px;
      }
      ::-webkit-scrollbar-corner {background: rgba(0,0,0,0.5);}
    `, n);
}
function B(n, e) {
  const t = window.URL.createObjectURL(n), i = document.createElement("a");
  i.style.display = "none", i.href = t, i.download = e, document.body.appendChild(i), i.click(), setTimeout(() => {
    document.body.removeChild(i), window.URL.revokeObjectURL(t);
  }, 1e3);
}
async function Y(n) {
  return new Promise((e, t) => {
    const i = new FileReader();
    i.onload = (r) => e(i.result), i.onerror = (r) => t(i.error), i.onabort = (r) => t(new Error("Read aborted")), i.readAsDataURL(n);
  });
}
function Ee(n, e) {
  return B(n, e ?? n.name);
}
async function Ce(n = !1, e = !1, t) {
  const i = document.createElement("input");
  i.type = "file", i.multiple = n, i.accept = t || "*", i.webkitdirectory = e, i.style.display = "none", document.body.appendChild(i), i.click();
  const r = await new Promise((o) => {
    i.onchange = (s) => {
      o(Array.from(i.files || []));
    };
  });
  return document.body.removeChild(i), r;
}
function _e() {
  let n = !1;
  return function(e) {
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (n = !0);
  }(navigator.userAgent || navigator.vendor || window.opera), n;
}
function Se(n) {
  return n < 0.04045 ? n * 0.0773993808 : Math.pow(n * 0.9478672986 + 0.0521327014, 2.4);
}
function Le(n) {
  return n < 31308e-7 ? n * 12.92 : 1.055 * Math.pow(n, 0.41666) - 0.055;
}
function Ue(n, e = 1, t = 1) {
  const i = document.createElement("canvas");
  i.width = e, i.height = t;
  const r = i.getContext("2d");
  r.fillStyle = "#" + n, r.fillRect(0, 0, e, t);
  const o = i.toDataURL();
  return i.remove(), o;
}
function K(n, e) {
  let t;
  do
    t = Object.getOwnPropertyDescriptor(n, e);
  while (!t && (n = Object.getPrototypeOf(n)));
  return t;
}
function V(n, e, t = !0, i = !1) {
  const r = K(n, e);
  return !!(r != null && r.set) || t && (r == null ? void 0 : r.writable) !== !1 && (r == null ? void 0 : r.get) === void 0 || i && !r;
}
function U(n, e, t, i = !0, r = !1) {
  return n && V(n, e, i, r) ? (n[e] = t, !0) : !1;
}
function ze(n, ...e) {
  return typeof n == "function" && (n = n(...e)), n;
}
function Ae(n, e, t) {
  for (const i of t) {
    const r = n[i];
    r !== void 0 && U(e, i, r, !0);
  }
  return e;
}
function Oe(n, e) {
  for (const t of e)
    if (!n.includes(t)) return !1;
  return !0;
}
function J(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    if (e(n[t])) return t;
  return -1;
}
function De(n, e) {
  return function(...t) {
    return n(), e && e.call(this, ...t);
  };
}
function Ie(n, e) {
  return function(...t) {
    return n(...t), e && e.call(this, ...t);
  };
}
function Te(n, e, t = !1) {
  for (typeof n == "string" && (n = n.split(".")); n.length > 0; ) {
    if (!e) return e;
    const i = n.splice(0, 1)[0];
    if (!(i.length < 1))
      if (Array.isArray(e))
        e = e[parseInt(i)];
      else if (typeof e == "object" && i in e)
        e = e[i];
      else {
        if (t)
          throw new Error("invalid access, check " + i + " in " + e);
        return;
      }
  }
  return e;
}
function Pe(n, e) {
  return Object.keys(n).find((t) => n[t] === e);
}
function b(n, e) {
  return Object.hasOwn ? Object.hasOwn(n, e) : n.hasOwnProperty(e);
}
function Me(n, e, t = !0) {
  const i = t ? n : {}, r = Object.keys(n);
  for (const o of r) i[o] = e(n[o], o);
  return i;
}
function L(n, e) {
  return Object.fromEntries(Object.entries(n).map((t) => e(t)));
}
const x = {
  // object
  priority: 1 / 0,
  serialize: (n, e) => L(n, ([t, i]) => [t, p.Serialize(i, e, !1)]),
  deserialize: (n, e, t) => Object.assign(e || {}, L(n, ([i, r]) => [i, p.Deserialize(r, e == null ? void 0 : e[i], t, !1)])),
  isType: (n) => (n.constructor || Object) === Object
}, u = class u {
  static GetSerializer(e) {
    return u.Serializers.find((t) => t.isType(e));
  }
  static RegisterSerializer(...e) {
    for (const t of e) {
      const i = t.priority ?? 1e10, r = J(u.Serializers, (o) => o.priority !== void 0 && o.priority < i);
      r >= 0 ? u.Serializers.splice(r + 1, 0, t) : u.Serializers.push(t);
    }
  }
  static UnregisterSerializer(...e) {
    for (const t of e) {
      const i = u.Serializers.indexOf(t);
      i >= 0 && u.Serializers.splice(i, 1);
    }
  }
  /**
   * Serialize an object
   * @param obj - object to serialize
   * @param meta - Optional object to store common meta-data/resources across the serialization process of multiple objects
   * @param isThis - true if called from inside the serialization function, like custom {@link IJSONSerializable.toJSON}.
   */
  static Serialize(e, t, i = !1) {
    if (typeof e == "function") return;
    if (!i) {
      const s = u.GetSerializer(e);
      if (s) return s.serialize(e, t);
      if (typeof e.toJSON == "function") {
        const a = e.toJSON(t, !0);
        return e.serializableClassId && a && (a.serializableClassId = e.serializableClassId), a;
      }
    }
    let r = e.constructor ?? Object;
    const o = {};
    for (; r && r !== Object; ) {
      const s = u.TypeMap.get(r) ?? [];
      for (const [a, c] of s)
        o[a] = u.Serialize(e[c], t, !1);
      r = Object.getPrototypeOf(r);
    }
    return e.serializableClassId && (o.serializableClassId = e.serializableClassId), o;
  }
  /**
   * Deserialize an object
   * @param data - data to deserialize
   * @param obj - current object that's set. If of the same class/type the data is deserialized into that instead of creating new objects.
   * @param meta - Optional object to retrieve common meta-data/resources across the deserialization process of multiple objects. Objects in meta must be class instances, not js objects. (like Material, Texture, Object3D etc)
   * @param isThis - true if called from inside the deserialization function, like custom {@link IJSONSerializable.fromJSON}
   */
  static Deserialize(e, t, i, r = !1) {
    if (e === void 0 || t === e) return t;
    if (e && typeof e == "object" && (e.constructor || Object) === Object && e.resource && typeof e.resource == "string" && e.uuid) {
      const s = i == null ? void 0 : i[e.resource];
      if (s) {
        if (e = s[e.uuid], typeof e == "object" && (e.__useCount = e.__useCount ? e.__useCount + 1 : 1), e || console.warn(`Resource ${e.resource} with uuid ${e.uuid} not found`), t === e) return t;
        if (e && typeof e == "object") {
          if ((e.constructor || Object) !== Object)
            return t && console.warn("replacing object", t, "with deserialized object from meta", e), e;
          console.error("Deserialize; meta should only have class instances, not js objects", e, t, i);
        }
      } else
        return console.warn(`Resource ${e.resource} not found`), t;
    }
    if (e && typeof e == "object" && (e.constructor || Object) !== Object && !Array.isArray(e) && !e.serializableClassId) {
      if (e instanceof Blob) return e;
      console.warn("Data might already be deserialized. It will be cloned, or copied to source", e, "source", t, e.constructor, e.constructor !== Object);
    }
    if (e && typeof e == "object")
      if (e.serializableClassId && (!t || t.serializableClassId !== e.serializableClassId)) {
        const s = u.SerializableClasses.get(e.serializableClassId);
        s && (s.DataInConstructor ? t = new s(e) : t = new s());
      } else (e.constructor || Object) === Object && !t ? t = {} : Array.isArray(e) && !t && (t = []);
    if (typeof t == "function")
      return console.error("cannot deserialize a function", t, e), t;
    if (!r) {
      const s = u.GetSerializer(e);
      if (s && s !== x) return s.deserialize(e, t, i);
    }
    if (!e || t === void 0 || t === null || typeof t != "object")
      return e;
    if (!r && typeof (t == null ? void 0 : t.fromJSON) == "function")
      return t.fromJSON(e, i, !0), t;
    let o = t.constructor ?? Object;
    if (o === Object) return x.deserialize(e, t, i);
    for (; o && o !== Object; ) {
      const s = u.TypeMap.get(o) ?? [];
      for (const [a, c] of s) {
        const l = t[c], d = u.Deserialize(e[a], l, i, !1);
        d !== l && U(t, c, d, !0);
      }
      o = Object.getPrototypeOf(o);
    }
    return t;
  }
};
u.TypeMap = /* @__PURE__ */ new Map(), u.SerializableClasses = /* @__PURE__ */ new Map(), u.Serializers = [
  {
    // arrays
    priority: 0,
    isType: (e) => Array.isArray(e),
    serialize: (e, t) => e.map((i) => u.Serialize(i, t, !1)),
    deserialize: (e, t, i) => {
      const r = e.length;
      Array.isArray(t) || (t = []);
      for (let o = 0; o < r; o++) {
        const s = e[o], a = t.length > o ? u.Deserialize(s, t[o], i, !1) : u.Deserialize(s, void 0, i, !1);
        t.length <= o ? t.push(a) : t[o] = a;
      }
      return t;
    }
  },
  {
    // primitives
    priority: 0,
    isType: (e) => !e || typeof e != "object",
    serialize: (e) => {
      if (e && typeof e == "number") {
        if (e === 1 / 0) return "Infinity";
        if (e === -1 / 0) return "-Infinity";
        if (isNaN(e)) return "NaN";
      }
      return e;
    },
    deserialize: (e, t) => {
      if (typeof t == "number") {
        if (e === "Infinity") return 1 / 0;
        if (e === "-Infinity") return -1 / 0;
        if (e === "NaN") return NaN;
        if (typeof e == "number" || !e) return e;
      }
      return e;
    }
  },
  x
];
let p = u;
const g = class g {
  static callFunction(e, t, i = []) {
    if (!t) return e(...i);
    if (e.name && t[e.name] === e) return e.call(t, ...i);
    g.methodMap.has(t) || g.methodMap.set(t, /* @__PURE__ */ new WeakMap());
    const r = g.methodMap.get(t);
    if (!r.has(e)) {
      let o = t;
      for (; o; ) {
        const s = Object.values(Object.getOwnPropertyDescriptors(o));
        for (let a of s)
          if (a.value === e)
            return r.set(e, !0), e.call(t, ...i);
        o = Object.getPrototypeOf(o);
      }
      r.set(e, !1);
    }
    return r.get(e) ? e.call(t, ...i) : e(...i);
  }
};
g.methodMap = /* @__PURE__ */ new WeakMap();
let E = g;
function C(n, e = "param") {
  if (!n) throw new Error("onChange: fnKey is undefined, make sure the function exists or provide a string");
  return (t, i, r) => {
    const o = {
      get() {
        return this[`_oc_${i}`];
      },
      set(s) {
        var l;
        const a = this[`_oc_${i}`];
        if (a === s) return;
        this[`_oc_${i}`] = s;
        const c = e === "param" ? [i, s, a, this] : e === "object" ? [{ key: i, value: s, oldValue: a, target: this }] : [];
        typeof n == "string" ? (l = this[n]) == null || l.call(this, ...c) : typeof n == "function" && E.callFunction(n, this, c);
      }
    };
    if (r)
      return b(r, "value") && delete r.value, b(r, "writable") && delete r.writable, b(r, "initializer") && delete r.initializer, Object.assign(r, o);
    Object.defineProperty(t, i, o);
  };
}
function $e(n, e = "void") {
  if (!n) throw new Error("onChange: fnKey is undefined, make sure the function exists or provide a string");
  return C(n, e);
}
function Re(n, e = "object") {
  if (!n) throw new Error("onChange: fnKey is undefined, make sure the function exists or provide a string");
  return C(n, e);
}
function Fe(n) {
  return C((e, t, i, r) => {
    if (!r.dispatchEvent) throw new Error("onChangeDispatchEvent: target does not have dispatchEvent");
    r.dispatchEvent({ type: n || `${e}-changed`, detail: { key: e, value: t, oldValue: i } });
  }, "param");
}
function Ne(n) {
  return (e, t) => {
    const i = e.constructor;
    if (i === Object) throw new Error("All properties in an object are serialized by default");
    p.TypeMap.has(i) || p.TypeMap.set(i, []), p.TypeMap.get(i).push([n || t, t]);
  };
}
function qe(n) {
  return (e) => (e = class extends e {
    constructor() {
      super(...arguments), this.serializableClassId = n;
    }
    // static DataInConstructor = false // if constructor is equivalent to fromJSON, see LUTCubeTextureWrapper.
  }, p.SerializableClasses.set(n, e), e);
}
async function He(n, e, t, i = 12) {
  const r = typeof e == "string" ? new TextEncoder().encode(e) : e, o = await crypto.subtle.digest("SHA-256", r), s = crypto.getRandomValues(new Uint8Array(i)), a = Array.from(s).map((v) => String.fromCharCode(v)).join(""), c = { name: "AES-GCM", iv: s }, l = await crypto.subtle.importKey("raw", o, c, !1, ["encrypt"]), d = typeof n == "string" ? new TextEncoder().encode(n) : n, f = await crypto.subtle.encrypt(c, l, d), D = new Uint8Array(f), _ = Array.from(D), I = _.map((v) => String.fromCharCode(v)).join(""), T = t ? typeof t == "string" ? t : new TextDecoder().decode(t) : "", P = t ? typeof t == "string" ? new TextEncoder().encode(t) : Array.from(t) : [];
  return typeof n == "string" ? T + a + I : new Uint8Array([...P, ...s, ..._]);
}
async function We(n, e, t = 12) {
  const i = typeof e == "string" ? new TextEncoder().encode(e) : e, r = await crypto.subtle.digest("SHA-256", i), o = n.slice(0, t), a = { name: "AES-GCM", iv: typeof o == "string" ? new Uint8Array(Array.from(o).map((f) => f.charCodeAt(0))) : o }, c = await crypto.subtle.importKey("raw", r, a, !1, ["decrypt"]), l = n.slice(t), d = typeof l == "string" ? new Uint8Array(Array.from(l).map((f) => f.charCodeAt(0))) : l;
  try {
    const f = await crypto.subtle.decrypt(a, c, d);
    return typeof n == "string" ? new TextDecoder().decode(f) : new Uint8Array(f);
  } catch {
    throw new Error("Decrypt failed");
  }
}
async function Be() {
  return "showOpenFilePicker" in window ? window.showOpenFilePicker().then((n) => n[0]) : window.chooseFileSystemEntries();
}
function Ye() {
  if ("showSaveFilePicker" in window) {
    const e = {
      types: [{
        description: "Text file",
        accept: { "text/plain": [".txt"] }
      }]
    };
    return window.showSaveFilePicker(e);
  }
  const n = {
    type: "save-file",
    accepts: [{
      description: "Text file",
      extensions: ["txt"],
      mimeTypes: ["text/plain"]
    }]
  };
  return window.chooseFileSystemEntries(n);
}
function Ke(n) {
  return n.text ? n.text() : G(n);
}
function G(n) {
  return new Promise((e) => {
    const t = new FileReader();
    t.addEventListener("loadend", (i) => {
      const r = (i.srcElement || i.target).result;
      e(r);
    }), t.readAsText(n);
  });
}
async function Ve(n, e) {
  if (n.createWriter) {
    const i = await n.createWriter();
    await i.write(0, e), await i.close();
    return;
  }
  const t = await n.createWritable();
  await t.write(e), await t.close();
}
async function Je(n, e) {
  const t = {};
  return e && (t.writable = !0, t.mode = "readwrite"), await n.queryPermission(t) === "granted" || await n.requestPermission(t) === "granted";
}
function z(n, e = 8192, t = !1) {
  var s;
  if (!n.width || !n.height) throw new Error("Invalid bitmap");
  const i = document.createElement("canvas");
  i.width = Math.min(e, n.width), i.height = Math.floor(1 + i.width * n.height / n.width);
  const r = n instanceof ImageBitmap, o = r && t && Math.abs(i.width - n.width) < 0.5 ? i.getContext("bitmaprenderer") : void 0;
  return o ? o.transferFromImageBitmap(n) : (s = i.getContext("2d")) == null || s.drawImage(n, 0, 0, i.width, i.height), r && t && n.close(), i;
}
function Ge(n, e = 8192, t = !1, i = "image/png") {
  if (!n.width || !n.height) return "";
  const r = z(n, e, !1), o = r.toDataURL(i);
  return r.remove(), t && n instanceof ImageBitmap && n.close(), o;
}
async function Xe(n, e = 8192, t = !1, i = "image/png") {
  if (!n.width || !n.height) return Promise.reject("Invalid bitmap");
  const r = z(n, e, !1);
  return new Promise((o, s) => {
    r.toBlob((a) => {
      a ? o(a) : s("Could not get blob"), r.remove(), t && n instanceof ImageBitmap && n.close();
    }, i);
  });
}
async function Ze(n) {
  return new Promise((e, t) => {
    const i = new Image();
    i.addEventListener("load", () => {
      const r = document.createElement("canvas");
      r.width = i.width, r.height = i.height;
      const o = r.getContext("2d");
      if (!o) {
        t(new Error("Could not get 2d context"));
        return;
      }
      o.drawImage(i, 0, 0, r.width, r.height);
      const s = o.getImageData(0, 0, r.width, r.height);
      e(s), r.remove(), i.remove();
    }, !1), i.addEventListener("error", (r) => {
      i.remove(), t(r);
    }, !1), i.src = n;
  });
}
function X(n, {
  backgroundColor: e = "",
  scale: t = 1,
  width: i = 512,
  height: r = 512
}) {
  const o = document.createElement("canvas"), s = o.getContext("2d"), a = t, c = i, l = r;
  return o.width = c * a, o.height = l * a, o.style.width = `${c}`, o.style.height = `${l}`, (e == null ? void 0 : e.length) > 0 && (s.fillStyle = e, s.fillRect(0, 0, o.width, o.height)), s.drawImage(n, 0, 0, o.width, o.height), o;
}
function Qe(n) {
  const e = document.createElement("canvas");
  return e.width = n.width, e.height = n.height, e.getContext("2d").putImageData(n, 0, 0), e;
}
function je() {
  const n = document.createElement("canvas");
  return n.getContext && n.getContext("2d") ? n.toDataURL("image/webp").startsWith("data:image/webp") : !1;
}
function et(n) {
  const e = document.createElement("canvas");
  e.width = n.width, e.height = n.height;
  const t = e.getContext("2d");
  if (!t) throw new Error("Unable to get 2d context");
  return t.translate(0, n.height), t.scale(1, -1), t.drawImage(n, 0, 0), e;
}
function tt(n) {
  return new Promise((e, t) => {
    const i = new Image(), r = URL.createObjectURL(n);
    i.onload = () => {
      URL.revokeObjectURL(r), e(i);
    }, i.onerror = (o) => {
      URL.revokeObjectURL(r), t(o);
    }, i.src = r;
  });
}
const nt = (n) => `data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' fill='%23${n}'/%3E%3C/svg%3E%0A`, it = (n) => `data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='7' fill='%23${n}'/%3E%3C/svg%3E%0A`, rt = (n) => `data:image/svg+xml,%3Csvg viewBox='0 0 80 14' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext style='font: 8px "Roboto Mono", "Source Code Pro", Menlo, Courier, monospace; fill: white;' x='9' y='9'%3E${n}%3C/text%3E%3C/svg%3E%0A`, A = async (n, e) => {
  const t = await $(n);
  return X(t, e);
}, Z = async (n, e) => await A(n, e).then((t) => t.toDataURL("image/png")), Q = async (n) => Y(await (await fetch(n)).blob());
async function ot(n, e = Q) {
  const t = n.match(/(((ftp|https?):\/\/)[\-\w@:%_\+.~#?,&\/\/=]+)/g);
  if (t)
    for (const i of t) {
      const r = await e(i);
      n = n.replace(i, r);
    }
  return n;
}
function O(n, e, { width: t, height: i }, r = !0) {
  const o = `
<svg viewBox="0 0 ${t} ${i}" xmlns="http://www.w3.org/2000/svg">
    <style>
    ${e}
    </style>
    <foreignObject x="0" y="0" width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; width: 100%; position: absolute: top:0; left:0">
            ${n}
        </div>
    </foreignObject>
</svg>
    `;
  return r ? W(o) : o;
}
async function st(n, e, t) {
  const i = O(n, e, t);
  return await A(i, t);
}
async function at(n, e, t) {
  const i = O(n, e, t);
  return await Z(i, t);
}
function ct(n, e) {
  return Math.abs(n) > Math.abs(e) ? n : e;
}
function lt(n, e, t) {
  const i = t ? 1 : 0, r = ~(1 << e);
  return n & r | i << e;
}
function ut(n, e) {
  const t = ~(1 << e);
  return n & t;
}
function dt() {
  const n = (i, r) => i.toString(16).padStart(r, "0"), e = crypto.getRandomValues(new Uint8Array(16));
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const t = new DataView(e.buffer);
  return `${n(t.getUint32(0), 8)}-${n(t.getUint16(4), 4)}-${n(t.getUint16(6), 4)}-${n(t.getUint16(8), 4)}-${n(t.getUint32(10), 8)}${n(t.getUint16(14), 4)}`;
}
function ht(n, e = null) {
  return new URL(window.location.href).searchParams.get(n) ?? e;
}
function ft(n, e, t = !1) {
  const i = new URLSearchParams(location.search);
  e == null ? i.has(n) && i.delete(n) : i.set(n, e), t ? window.location.search = i.toString() : window.history.replaceState({}, "", "?" + i.toString());
}
function pt(n, e = "/") {
  return n.join(e);
}
function mt(n, e) {
  const t = (e ? `var Module = { locateFile: function(s) { return "${e}"; } }; 
` : "") + `importScripts( "${n}" );`;
  return URL.createObjectURL(new Blob([t], { type: "text/javascript" }));
}
const gt = {
  alert: async (n) => window.alert(n),
  prompt: async (n, e, t) => window.prompt(n, e),
  confirm: async (n) => window.confirm(n),
  confirmSync: (n) => window.confirm(n)
}, j = '.dialog-container{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000;border-radius:10px;padding:20px;max-width:calc(100% - 32px);width:calc(100% - 32px);color:#0a0a0a;background-color:#fff;border:1px solid oklch(.922 0 0);box-shadow:#0000 0 0,#0000 0 0,#0000 0 0,#0000 0 0,#0000001a 0 10px 15px -3px,#0000001a 0 4px 6px -4px;display:flex;gap:1rem;flex-direction:column;box-sizing:border-box;font-family:Inter,-apple-system,"system-ui",Segoe UI,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji";transition:max-width .5s,width .5s,height .5s}.dialog-content{display:flex;flex-direction:column;gap:.5rem;text-align:center}.dialog-title{font-size:1.125rem;font-weight:600;line-height:1.5;color:#0a0a0a}.dialog-message{color:#737373;font-size:.875rem;line-height:1.42}.dialog-footer{display:flex;gap:10px;flex-direction:column-reverse}@media (width >= 40rem){.dialog-content{text-align:left}.dialog-container{max-width:512px;width:512px}.dialog-footer{flex-direction:row;justify-content:flex-end}}.dialog-button,.dialog-input{height:2.25rem;box-sizing:border-box}.dialog-input{width:100%;padding:.25rem .75rem;font-size:1rem;border:1px solid oklch(.922 0 0);border-radius:.5rem;background:transparent;color:#0a0a0a;outline:none;transition:outline-width .2s}.dialog-button{padding:.5rem 1rem;box-shadow:#0000 0 0,#0000 0 0,#0000 0 0,#0000000d 0 1px 2px;border-radius:.5rem;border:1px solid oklch(.922 0 0);cursor:pointer;font-size:.875rem;background-color:#fff;color:#0a0a0a;transition:background-color .2s ease,color .2s ease,outline-width .2s ease}.dialog-button:focus,.dialog-input:focus{outline:3px solid #6d7a8c66}.dialog-button:hover{background-color:#f8f8f8}.dialog-ok{background-color:#0a0a0a;color:#fff}.dialog-ok:hover{background-color:#222}';
let y = null;
const ee = (n) => `
<div class="dialog-content">
    ${n.title ? `<div class="dialog-title">${n.title}</div>` : ""}
    <div class="dialog-message">${n.message}</div>
</div>
<div class="dialog-footer">
    ${n.ok && `<button class="dialog-button dialog-ok">${n.ok}</button>` || ""}
</div>
`, te = (n) => `
<div class="dialog-content">
    ${n.title ? `<div class="dialog-title">${n.title}</div>` : ""}
    <div class="dialog-message">${n.message}</div>
</div>
<div class="dialog-footer">
    ${n.cancel && `<button class="dialog-button dialog-cancel">${n.cancel}</button>` || ""}
    ${n.ok && `<button class="dialog-button dialog-ok">${n.ok}</button>` || ""}
</div>
`, ne = (n) => `
<div class="dialog-content">
    ${n.title ? `<div class="dialog-title">${n.title}</div>` : ""}
    <div class="dialog-message">${n.message}</div>
    <input class="dialog-input" type="text" value="${n.defaultValue ?? ""}" style="margin-top:0.5rem;"/>
</div>
<div class="dialog-footer">
    ${n.cancel && `<button class="dialog-button dialog-cancel">${n.cancel}</button>` || ""}
    ${n.ok && `<button class="dialog-button dialog-ok">${n.ok}</button>` || ""}
</div>
`;
function ie() {
  y || (y = document.createElement("style"), y.textContent = j, document.head.appendChild(y));
}
function k(n, { message: e, ...t }) {
  ie();
  const i = document.createElement("div"), r = e == null ? void 0 : e.split(":")[0];
  return r && e && (e = e.replace(r + ":", "").trim()), i.innerHTML = n({ ...t, message: e, title: r }), i.classList.add("dialog-container"), document.body.appendChild(i), i;
}
const wt = {
  alert: async (n) => {
    const e = k(ee, { message: n || "Alert", ok: "Okay" });
    return new Promise((t) => {
      const i = e.querySelector(".dialog-ok"), r = (s) => {
        (s.key === "Enter" || s.key === "Escape") && (s.preventDefault(), i == null || i.click());
      }, o = () => {
        window.removeEventListener("keydown", r), document.body.removeChild(e);
      };
      window.addEventListener("keydown", r), i == null || i.addEventListener("click", () => {
        o(), t();
      }), i == null || i.focus();
    });
  },
  prompt: async (n, e, t = !0) => {
    const i = k(ne, {
      message: n || "Enter some text",
      ok: "OK",
      cancel: t ? "Cancel" : void 0,
      defaultValue: e
    });
    return new Promise((r) => {
      const o = i.querySelector(".dialog-ok"), s = i.querySelector(".dialog-cancel"), a = i.querySelector(".dialog-input");
      a.addEventListener("keydown", (d) => {
        d.key === "Enter" && (d.preventDefault(), o == null || o.click());
      });
      const c = (d) => {
        d.key === "Escape" && s && (d.preventDefault(), s == null || s.click());
      }, l = () => {
        window.removeEventListener("keydown", c), document.body.removeChild(i);
      };
      window.addEventListener("keydown", c), o == null || o.addEventListener("click", () => {
        const d = a.value;
        l(), r(d);
      }), s == null || s.addEventListener("click", () => {
        l(), r(null);
      }), a == null || a.focus(), a == null || a.select();
    });
  },
  confirm: async (n) => {
    const e = k(te, { message: n || "Are you sure?", ok: "Yes", cancel: "No" });
    return new Promise((t) => {
      const i = e.querySelector(".dialog-ok"), r = e.querySelector(".dialog-cancel"), o = (a) => {
        a.key === "Escape" && r && (a.preventDefault(), r.click());
      }, s = () => {
        window.removeEventListener("keydown", o), document.body.removeChild(e);
      };
      window.addEventListener("keydown", o), i == null || i.addEventListener("click", () => {
        s(), t(!0);
      }), r == null || r.addEventListener("click", () => {
        s(), t(!1);
      }), r == null || r.focus();
    });
  },
  confirmSync: (n) => window.confirm(n)
};
export {
  S as Damper,
  E as FnCaller,
  se as JSUndoManager,
  Le as LinearToSRGB,
  oe as PointerDragHelper,
  Se as SRGBToLinear,
  p as Serialization,
  M as SimpleEventDispatcher,
  N as TYPED_ARRAYS,
  ct as absMax,
  We as aesGcmDecrypt,
  He as aesGcmEncrypt,
  de as arrayBufferToBase64,
  he as base64ToArrayBuffer,
  Y as blobToDataURL,
  tt as blobToImage,
  et as canvasFlipY,
  ut as clearBit,
  F as cloneScriptTag,
  Ue as colorToDataUrl,
  Ae as copyProps,
  ae as createCanvasElement,
  ce as createDiv,
  $ as createImage,
  le as createScriptFromURL,
  R as createStyles,
  H as css,
  Te as deepAccessObject,
  B as downloadBlob,
  Ee as downloadFile,
  ot as embedUrlRefs,
  q as escapeRegExp,
  J as findLastIndex,
  Be as getFileHandle,
  we as getFilenameFromPath,
  Pe as getKeyByValue,
  Ye as getNewFileHandle,
  ze as getOrCall,
  K as getPropertyDescriptor,
  fe as getTypedArray,
  ht as getUrlQueryParam,
  be as glsl,
  xe as html,
  wt as htmlDialogWrapper,
  st as htmlToCanvas,
  at as htmlToPng,
  O as htmlToSvg,
  Ge as imageBitmapToBase64,
  Xe as imageBitmapToBlob,
  z as imageBitmapToCanvas,
  Qe as imageDataToCanvas,
  X as imageToCanvas,
  Ze as imageUrlToImageData,
  Oe as includesAll,
  V as isPropertyWritable,
  je as isWebpExportSupported,
  ve as longestCommonPrefix,
  nt as makeColorSvg,
  it as makeColorSvgCircle,
  rt as makeTextSvg,
  _e as mobileAndTabletCheck,
  w as now,
  b as objectHasOwn,
  Me as objectMap,
  L as objectMap2,
  C as onChange,
  $e as onChange2,
  Re as onChange3,
  Fe as onChangeDispatchEvent,
  ge as parseFileExtension,
  pt as pathJoin,
  ke as prettyScrollbar,
  Ke as readFile,
  mt as remoteWorkerURL,
  h as replaceAll,
  ye as safeReplaceString,
  U as safeSetProperty,
  qe as serializable,
  Ne as serialize,
  ue as setInnerHTMLWithScripts,
  ft as setUrlQueryParam,
  A as svgToCanvas,
  Z as svgToPng,
  W as svgUrl,
  re as timeout,
  me as toCamelCase,
  pe as toTitleCase,
  lt as updateBit,
  Ce as uploadFile,
  dt as uuidV4,
  Je as verifyPermission,
  gt as windowDialogWrapper,
  De as wrapThisFunction,
  Ie as wrapThisFunction2,
  Ve as writeFile
};
//# sourceMappingURL=bundle.esm.js.map
